<template>
  <panel
    :title="title"
    :breadcrumbs="breadcrumbs"
  >
    <v-card>
      <v-card-text class="text-xs-center">
        <template v-if="loading">
          <v-progress-circular
            indeterminate
            color="primary"
            size="48"
          />
          <p class="mt-3">
            Verifying payment status...
          </p>
        </template>

        <template v-else-if="normalizedStatus === 'SUCCESS'">
          <v-icon
            color="success"
            size="64"
          >
            mdi-check-circle
          </v-icon>
          <h2 class="headline success--text mt-3">
            Payment Successful
          </h2>
          <p class="mt-2">
            Your D288 dealer appointment order has been submitted successfully.
          </p>
          <p v-if="transactionId">
            Transaction ID: {{ transactionId }}
          </p>
        </template>

        <template v-else-if="normalizedStatus === 'CANCEL'">
          <v-icon
            color="warning"
            size="64"
          >
            mdi-alert-circle
          </v-icon>
          <h2 class="headline warning--text mt-3">
            Payment Cancelled
          </h2>
          <p class="mt-2">
            {{ errorMessage || 'You cancelled the payment at the gateway.' }}
          </p>
          <p v-if="transactionId">
            Transaction ID: {{ transactionId }}
          </p>
        </template>

        <template v-else>
          <v-icon
            color="error"
            size="64"
          >
            mdi-close-circle
          </v-icon>
          <h2 class="headline error--text mt-3">
            Payment Failed
          </h2>
          <p class="mt-2">
            {{ errorMessage || 'We could not confirm your payment status.' }}
          </p>
          <p v-if="transactionId">
            Transaction ID: {{ transactionId }}
          </p>
        </template>

        <v-btn
          color="primary"
          class="mt-3"
          to="/dealership_kits"
        >
          Back to Dealership Kits
        </v-btn>
      </v-card-text>
    </v-card>
  </panel>
</template>

<script>
import { createGetParams } from '@/rest'

const pageTitle = 'D288 Payment Status'

export default {
  components: {
    Panel: () => import(/* webpackChunkName: "panel" */ '@/components/Panel'),
  },

  data () {
    return {
      title: pageTitle,
      breadcrumbs: [
        {
          text: 'Dealer Kits', disabled: false, to: '/dealer_kits',
        },
        {
          text: 'Dealership', disabled: false, to: '/dealership_kits',
        },
        {
          text: pageTitle, disabled: true,
        },
      ],
      loading: true,
      status: null,
      errorMessage: null,
      merchantId: this.$route.query.merchant_id,
      transactionId: this.$route.query.transactionId,
    }
  },

  computed: {
    normalizedStatus () {
      return this.status ? String(this.status).toUpperCase() : null
    },
  },

  mounted () {
    this.checkOrderStatus()
  },

  methods: {
    checkOrderStatus () {
      if (!this.merchantId || !this.transactionId) {
        this.loading = false
        this.status = 'FAIL'
        this.errorMessage = 'Missing payment reference.'
        return
      }

      const params = createGetParams({
        merchantId: this.merchantId,
        transactionId: this.transactionId,
      })

      this.$rest.get('getD288OrderStatus.php', params)
        .then(response => {
          this.status = response.data.status
          this.errorMessage = response.data.message
        })
        .catch(error => {
          this.status = 'FAIL'
          this.errorMessage = error.response && error.response.data
            ? error.response.data
            : error.message
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
